import { formatPriceAmount } from "../../../../utils/numbers"
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "../../../ui/accordion"
import { Separator } from "../../../ui/separator"
import BodyItem from "./BodyItem"
import {
	TableOrderSubTransactionArs,
	TableOrderSubTransactionCrypto,
} from "../../../tables/transactions-table/data/types"

const TransactionsAccordion = ({
	transactions,
	variant,
}:
	| {
			transactions: TableOrderSubTransactionArs[]
			variant: "transfer"
	  }
	| {
			transactions: TableOrderSubTransactionCrypto[]
			variant: "crypto"
	  }) => {
	switch (variant) {
		case "transfer":
			return (
				<Accordion
					type="single"
					collapsible
					className="border border-border-onModal rounded-sm px-betweenComponents"
				>
					{transactions?.map((transaction: TableOrderSubTransactionArs) => (
						<AccordionItem value={transaction.transactionId}>
							<AccordionTrigger>
								{formatPriceAmount(
									transaction.amount,
									undefined,
									transaction.currency
								)}{" "}
								{transaction.currency}
							</AccordionTrigger>
							<AccordionContent>
								<BodyItem
									name="CUIT"
									value={transaction.sender.cuit}
									copy={true}
									overflow={true}
								/>
								<BodyItem
									name={
										transaction.sender.bank_entity?.entity_type === "psp"
											? "CVU"
											: "CBU"
									}
									value={transaction.sender.cvu}
									copy={true}
									overflow={true}
								/>
								{transaction.sender.bank_entity?.id && (
									<BodyItem
										name="Banco"
										value={transaction.sender.bank_entity.name}
										copy={true}
										overflow={true}
									/>
								)}
								<Separator
									orientation="horizontal"
									className="bg-border my-2"
								/>
								<BodyItem
									name="Fecha"
									value={transaction.time.formatted.date}
								/>
								<BodyItem name="Hora" value={transaction.time.formatted.time} />
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			)
		case "crypto":
			return (
				<Accordion
					type="single"
					collapsible
					className="border border-border-onModal rounded-sm px-betweenComponents"
				>
					{transactions?.map((transaction: TableOrderSubTransactionCrypto) => (
						<AccordionItem value={transaction.transactionId}>
							<AccordionTrigger>
								{formatPriceAmount(transaction.creditedInRequestedCurrency.amount)} {transaction.creditedInRequestedCurrency.currency}
							</AccordionTrigger>
							<AccordionContent>
								<BodyItem
									name="Hash de transacción"
									value={transaction.transactionHash}
									copy={true}
									overflow={true}
								/>
								{transaction.sender.address && (
									<BodyItem
										name="Dirección de origen"
										value={transaction.sender.address}
										copy={true}
										overflow={true}
									/>
								)}
								<BodyItem
									name="Fecha"
									value={transaction.time.formatted.time}
								/>
								<BodyItem name="Hora" value={transaction.time.formatted.date} />
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			)
	}
}

export default TransactionsAccordion
